$(function () {
  let section = $('#seccionPedidos')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, buscar: null, forma_pago: null, producto_id: null, cliente_id: null,
        fecha_inicio: null, fecha_fin: null},
      pedidos: [],
      clientes: [],
      pedido: {},

    },

    mounted() {
      const params = new URLSearchParams(window.location.search);
      this.filtros.producto_id = params.get('producto_id');
      this.filtros.cliente_id = params.get('cliente_id');
      const urlSinParams = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, urlSinParams);

      this.initDatePicker()
      this.clientes = clientesJson;
      this.getPedidos()
    },
    methods: {
      getEncodedParams(){
        let params = Object.assign({}, this.filtros)
        delete params.page
        delete params.from
        delete params.to
        delete params.per_page
        delete params.total
        if(params.buscar == null || params.buscar.length == 0){
          delete params.buscar
        }
        if(params.forma_pago == null || params.forma_pago.length == 0){
          delete params.forma_pago
        }
        if(params.producto_id == null || params.producto_id.length == 0){
          delete params.producto_id
        }
        if(params.cliente_id == null || params.cliente_id.length == 0){
          delete params.cliente_id
        }
        if(params.fecha_inicio == null || params.fecha_inicio.length == 0){
          delete params.fecha_inicio
        }
        if(params.fecha_fin == null || params.fecha_fin.length == 0){
          delete params.fecha_fin
        }
        return new URLSearchParams(params).toString();
      },
      getPedidos(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/pedidos/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(response.data.error, "", "info")
              return
            }
            vueApp.pedidos = response.data.pedidos.data;
            vueApp.filtros.total = response.data.pedidos.total;
            vueApp.filtros.per_page = response.data.pedidos.per_page;
            vueApp.filtros.from = response.data.pedidos.from;
            vueApp.filtros.to = response.data.pedidos.to;
          })
          .catch((error) => {
            vueApp.loader = false
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
      eliminar(id) {
        swalQ("¿Eliminar registro?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/pedidos/' + id)
              .then(function (response) {
                if (response.data.error) {
                  swal(response.data.error, "", "info")
                  return
                }
                vueApp.getPedidos(1)
              })
              .catch((error) => {
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      initDatePicker() {
        $('.fc-datepicker').datepicker({
          showOtherMonths: true,
          selectOtherMonths: true,
          autoclose: true,
          format: 'dd/mm/yyyy',
          language: 'es',
        })
        $('#fechaInicio')
          .datepicker()
          .on('changeDate', function (ev) {
            let fecha = $(ev.target).val()
            if (fecha != null) {
              fecha = fecha.split('/')
              fecha = [fecha[2], fecha[1], fecha[0]].join('-')
            }
            vueApp.filtros.fecha_inicio = fecha
            vueApp.getPedidos(1)
          })
        $('#fechaFin')
          .datepicker()
          .on('changeDate', function (ev) {
            let fecha = $(ev.target).val()
            if (fecha != null) {
              fecha = fecha.split('/')
              fecha = [fecha[2], fecha[1], fecha[0]].join('-')
            }
            vueApp.filtros.fecha_fin = fecha
            vueApp.getPedidos(1)
          })
      },
      detalle(pedido){
        this.pedido = Object.assign({}, pedido)
        $('#modalPedido').modal('show')
      }
    },
  })
})
